<template>
  <div class="bg auth-screen">
    <div class="container pt-120">
      <div class="card" v-if="!resetLinkSent">
        <div class="card-body">
          <h2 class="card-title">Forgot password</h2>
          <div class="card-description">
            Please enter your email address and we will send you a password reset link.
          </div>
          <form>
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                v-validate="'required|email'"
                name="email"
                :class="{
                  input: true,
                  'is-danger': errors.has('email'),
                  'is-success': !errors.has('email')
                }"
                class="form-control form-control-lg"
                v-model="user.username"
                placeholder="Enter your email address"
                required
              />
              <span v-show="errors.has('email')" class="text-danger">{{ errors.first("email") }}</span>
            </div>
            <p class="text-danger" v-if="errorMsg">{{ errorMsg }}</p>
            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-block" :disabled="errors.any() || !isCompleted" v-on:click.prevent="requestPassword">
                Get reset link
              </button>
            </div>
          </form>
          <div class="footer-links">
            <router-link :to="{ name: 'login' }">Back to sign in</router-link>
          </div>
        </div>
      </div>
      <div class="card" v-else>
        <div class="card-body">
          <h2 class="card-title">Check your email</h2>
          <div class="card-description">
            We've sent you a password reset link.<br />
            See you back here soon!
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block" v-on:click.prevent="goToLoginPage">
              Sign in
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "forgotPassword",
  data() {
    return {
      user: {
        username: ""
      },
      formErrors: false,
      resetLinkSent: false,
      errorMsg: null
    };
  },
  computed: {
    isCompleted() {
      return this.user.username != "";
    }
  },
  mounted() {
    this.userLogout();
  },
  methods: {
    ...mapActions(["userLogout"]),
    requestPassword() {
      this.user.username = this.user.username.toLowerCase();
      this.$api.sendForgotPwdEmailFact({ userName: this.user.username }).then(
        () => {
          this.resetLinkSent = true;
          this.$toastr.success("Email has been sent to your mail box");
          this.$store.dispatch("forgotPasswordSuccessAction", this.user);
        },
        error => {
          this.errorMsg = error.body && error.body.message ? error.body.message : "Error while requesting to change the password";
          this.$store.dispatch("forgotPasswordErrorAction", this.user);
        }
      );
    },
    goToLoginPage() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
